import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SampleStatusInfo } from './sample-status-info';
import { SampleStatusService } from './sample-status-service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'sample-status',
    template: require('./sample-status.component.html'),
    styles: [require('./sample-status.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleStatusComponent implements OnDestroy {

    @Input()
    public statusList: SampleStatusInfo[];

    @Output()
    public statusSelect = new EventEmitter<SampleStatusInfo>();

    private subscription: Subscription;

    private selectedStatusInfo: SampleStatusInfo;

    constructor(private sampleStatusService: SampleStatusService) {
        this.subscription = this.sampleStatusService.clearFilters$.subscribe(
            clearFilter => {
                if (clearFilter) {
                    this.statusList.forEach(t => t.selected = false);
                }
            });
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public handleNgclass(statusInfo: SampleStatusInfo) {
        return statusInfo.selected ? 'study-group-card' : 'study-group-card-selected';
    }

    public selectStatus(statusInfo: SampleStatusInfo) {
        if (statusInfo.disableNavigation) { return; }
        this.statusSelect.emit(statusInfo);

    }
}
